import { createSelector } from '@reduxjs/toolkit';
import { OnboardingState } from './onboarding.types';

export const selectOnboarding = (state) => state.onboarding;

export const selectOnboardingGymSearchText = createSelector(
  selectOnboarding,
  (state: OnboardingState) => state?.gyms?.filters?.searchText,
);
